import { createFileRoute } from '@tanstack/react-router'
import CreatePurchaseInvoiceScreen from './-components/screen'
import { pharmacyClient } from '@/connect'

import {z} from 'zod'
import { Loading } from '@/layouts/loading'
import { PharmacySize, StockPointType } from '@/gen/auth/common_pb'
const Params = z.object({
  instance_id: z.number().optional(),
})
type Params = z.infer<typeof Params>

export const Route = createFileRoute('/(pharma)/_layout/inventory/purchase-invoice/create/')({
  component: CreatePurchaseInvoiceScreen,
  validateSearch: Params,
  loaderDeps: ({ search: { instance_id } }) => ({
    instance_id
  }),
  loader: async () => {
    let stockPointId = undefined
    if (PharmacySize.SIZE_SMALL.toString() === localStorage.getItem('pharmacySize')) {
      const stockPoints = await pharmacyClient.getStockPoints({})
      for (const sp of stockPoints.stockPoints) {
        if (sp.stockPointType === StockPointType.RECEIVING) {
          stockPointId = sp.id
          break
        }
      }
    }

    const poList = await pharmacyClient.listPurchaseOrders({
      pageNumber: 1,
      pageSize: 100,
      includeUsed: false,
      stockPointId
    })
    const supplierList = await pharmacyClient.listSuppliers({
      page: 1,
      pageSize: 100,
    })
    return {
      purchaseOrders: poList.purchaseOrders,
      suppliers: supplierList.suppliers,
      stockPointId,
    }
  },
  pendingComponent: () => <Loading />,
  pendingMinMs: 1000,
  pendingMs: 1,
})